import React, { useEffect, useState } from 'react'
import './EventComponent.css'

// css flowbite
import { Breadcrumb, BreadcrumbItem } from "flowbite-react";
import { Link } from 'react-router-dom';
import EventServices from '../../services/EventServices';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { RiGraduationCapFill } from "react-icons/ri";
import logsUserService from '../../services/LogsUserActionService';

const EventComponent = () => {
  const [eventData, setEventData] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const { idUser, token } = useAuth();

  useEffect(() => {
    const getEvents = async () => {
      try {
        const responseEvents = await EventServices(token);
        setEventData(responseEvents);
      } catch (error) {
        setError(error);
      }
    }

    getEvents();
  }, [token]);


  const goToDetailEvent = (idEvent) => {
    navigate(`/eventos/${idEvent}`);
  }

  if (error) {
    return <p className="error-message W-75 d-flex justify-content-center align-items-center text-white">Error: {error}</p>;
  }

  return (
    <>
      <div className="breadcrumb-section mb-3">
        <Breadcrumb aria-label="Default breadcrumb example container main-section p-0">
          <ol className="flex items-center container main-section p-0">
            <BreadcrumbItem className="flex items-center text-md text-white hover:text-white dark:text-white dark:hover:text-white" href="#">
              <Link
                to="/home"
                className={`nav-link text-white ApisBold fs-5 text-decoration-none text-items-nav`}
                style={{ color: "inherit" }}
                onClick={() => logsUserService(idUser, "Clic en Inicio", token)}
              >
                Inicio
              </Link>
            </BreadcrumbItem>

            <BreadcrumbItem className="flex items-center text-md text-white no-underline hover:text-white dark:text-white dark:hover:text-white" href="#">
              <Link
                to="/eventos"
                className={`nav-link text-white ApisBold fs-5 text-dec text-items-nav`}
                style={{ color: "inherit" }}
                onClick={() => logsUserService(idUser, "Clic en Eventos", token)}
              >
                Eventos
              </Link>
            </BreadcrumbItem>
          </ol>
        </Breadcrumb>
      </div>


      {/* card principal */}
      <div className="container flex flex-col">
        <div className="relative">
          <div className="col-12 col-md-11 col-lg-12 background-e-learning top-0 p-0 pt-3 px-3 pb-5">

            <div className="h-auto sm:h-64 xl:h-80 2xl:h-96 grid grid-cols-1 gap-6 sm:grid-cols-2 gap-4 mt-5">
              <div className="flex flex-col items-center text-center">
                <button className="bg-dark-purple disabled md:w-80 lg:w-80 sm:w-full h-18 text-2xl text-white py-3 px-6 md:py-2 md:px-4 rounded-md">
                  Memorias
                </button>
                <p className='fs-5 mt-3 text-purple ApisRegular'>Consulte el contenido de eventos anteriores</p>

                {/* list of memorias */}
                <div className="overflow-y-auto w-full">
                  {eventData.map((event, index) => (
                    event.state_events === 'memory' && (
                      <div key={index} className="mt-2 container-btn-event max-w-xl w-full border-grueso rounded-lg shadow-md p-2 flex items-center justify-between hover:bg-gray-200 transition-colors duration-300 hover:text-dark-purple select-none cursor-pointer"
                      onClick={() => { goToDetailEvent(event.id); logsUserService(idUser, `Clic en memorias - ${event.name}`, token) }}>
                        <img src={event.picture} alt={"picture " + event.name} className="h-12 w-12 rounded-md ml-5" />
                        <div className="text-left flex-1 ml-2 flex items-center">
                          <h3 className="text-sm ApisBold text-purple mt-2">{event.name}</h3>
                        </div>
                      </div>
                    )
                  ))}
                </div>
              </div>

              <div className="flex flex-col items-center text-center">
                <button className="bg-custom-btn-register disabled md:w-80 lg:w-80 sm:w-full h-18 text-2xl text-white py-3 px-6 md:py-2 md:px-4 rounded-md">
                  Próximos eventos
                </button>
                <p className='mt-3 fs-5 text-purple ApisRegular'>Conozca nuestros próximos eventos</p>

                {/* eventos proximos a empezar */}
                <div className="overflow-y-auto w-full">
                  {eventData.map((event, index) => (
                    event.state_events === 'event' && (
                      <div key={index} className="mt-2 container-btn-event max-w-xl w-full border-grueso-lavender rounded-lg shadow-md p-2 flex items-center justify-between select-none cursor-pointer" 
                      onClick={() => { goToDetailEvent(event.id); logsUserService(idUser, `Clic en próximos eventos - ${event.name}`, token) }}>
                        <img src={event.picture} alt={"picture " + event.name} className="h-12 w-12 rounded-md ml-5 mr-2" />
                        <div className="text-left flex-1 ml-2">
                          <h3 className="text-sm ApisBold text-purple mt-2">{event.name}</h3>
                        </div>
                        {event.state_transmition === 'live' && (
                          <span className="bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-full mb-1 inline-block">en vivo</span>
                        )}
                      </div>
                    )
                  ))}
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </>
  )
}

export default EventComponent
